import React from "react";
import { ReactComponent as ChevroletDown } from "../../app/assets/icons/sorting/chevrolet-down.svg";
import { ReactComponent as ChevroletUp } from "../../app/assets/icons/sorting/chevrolet-up.svg";
import { ReactComponent as DefaultIcon } from "../../app/assets/icons/sorting/default-sorting-arrow.svg";

interface SortingIconProps {
  onClick?: () => void;
  direction?: string;
}

const SortingIcon: React.FC<SortingIconProps> = ({ onClick, direction }) => {
  return direction === "asc" ? (
    <span className="pb-1 m-1 toggle-eye" onClick={onClick}>
      <ChevroletDown />
    </span>
  ) : direction === "desc" ? (
    <span className="m-1 toggle-eye" onClick={onClick}>
      <ChevroletUp />
    </span>
  ) : (
    <span className="pb-1 m-1 toggle-eye" onClick={onClick}>
      <DefaultIcon />
    </span>
  );
};

export default SortingIcon;
